module.exports = __webpack_public_path__ + "63371b2d9a7e01a03a1c47ab7996c652.svg";